import { Skeleton, Stack } from '@mui/material';

import first from 'lodash/first';

import { TruncatedDisplayText } from '@/components/styled';
import { Avatar } from '@/sections/GlobalHeader/Left/WorkspaceLink/styled';

import { TeamNameProps } from './types';

function TeamName({
  name,
  icon,
  prefix,
  suffix,
  maxWidth = 123,
  gap = 1,
  loading = false,
}: TeamNameProps) {
  if (loading) {
    return <Skeleton animation="wave" width={120} />;
  }

  return (
    <Stack direction="row" gap={gap} alignItems="center">
      {prefix}
      <Avatar emoji={!!icon}>{icon || first(name)}</Avatar>
      <TruncatedDisplayText maxWidth={maxWidth}>{name}</TruncatedDisplayText>
      {suffix}
    </Stack>
  );
}

export default TeamName;
